<template>
    <section class="infographic light purple">
        <circles-layout></circles-layout>
        <div class="blocks-wrapper">
            <div class="block" ref="block">
                <h3>Leerlingen, studenten en cursisten</h3>
                <!-- p>Totaal - 13.967</p>
                <progress-bar :value="total" :max="13967"></progress-bar -->
                <p>Vo - 1.286</p>
                <progress-bar :value="vo" :max="maxChart"></progress-bar>
                <p>Vavo - 191</p>
                <progress-bar :value="vavo" :max="maxChart"></progress-bar>
                <p>Mbo BOL - 5.891</p>
                <progress-bar :value="bol" :max="maxChart"></progress-bar>
                <p>Mbo BBL (inclusief bedrijfsopleidingen) - 5.269</p>
                <progress-bar :value="bbl" :max="maxChart"></progress-bar>
                <p>Educatie & Inburgering - 408</p>
                <progress-bar :value="inburgering" :max="maxChart"></progress-bar>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_tekst.scss

    .rings-wrapper > div{
        width:33%;
    }
</style>

<script>
    import Circles from '@/app/components/circles';
    import ProgressBar from '@/app/components/progressBar';

    import { gsap } from 'gsap';

    export default {
        name: 'Info1',
        meta: {
            title: 'Info1',
            color: '#a5147e'
        },
        components: {
            'circles-layout': Circles,
            'progress-bar': ProgressBar
        },
        data()
        {
            return {
                maxChart: 7000,
                vo: 1286,
                vavo: 191,
                bol: 5891,
                bbl: 5269,
                inburgering: 408
            };
        },
        mounted()
        {
            this.tl = gsap.timeline({ paused: true });
            this.tl.from( this.$refs.block, { y: 100, autoAlpha: 0, duration: 0.3 }, 0 );
            this.tl.from( this, { mbo: 0, duration: 1, roundProps: 'mbo' }, 0.4 );
            this.tl.from( this, { vo: 0, duration: 1, roundProps: 'vo' }, 0.5 );
            this.tl.from( this, { bedrijf: 0, duration: 1, roundProps: 'bedrijf' }, 0.6 );
            this.tl.from( this, { bol: 0, duration: 1, roundProps: 'bol' }, 0.7 );
            this.tl.from( this, { bbl: 0, duration: 1, roundProps: 'bbl' }, 0.8 );
        },
        methods: {
            focus()
            {
                this.tl.play();
            },
            blur()
            {
                this.tl.reverse();
            }
        }
    };
</script>
